function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#XMLID_27_);fill:url(#SVGID_1_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_3_",
  d: "M256.3,228.7c-0.2,16.4,14.6,25.6,25.8,31c11.5,5.6,15.3,9.2,15.3,14.2c-0.1,7.7-9.2,11-17.7,11.2 c-14.8,0.2-23.4-4-30.3-7.2l-5.3,25c6.9,3.2,19.6,5.9,32.8,6.1c31,0,51.2-15.3,51.3-39c0.1-30.1-41.6-31.8-41.3-45.2 c0.1-4.1,4-8.4,12.5-9.5c4.2-0.6,15.9-1,29.1,5.1l5.2-24.2c-7.1-2.6-16.2-5.1-27.6-5.1C276.9,191.1,256.4,206.6,256.3,228.7  M383.5,193.1c-5.7,0-10.4,3.3-12.5,8.4l-44.2,105.6h31l6.2-17h37.8l3.6,17h27.3l-23.8-114H383.5 M387.8,223.9l8.9,42.8h-24.5 L387.8,223.9 M218.7,193.1l-24.4,114h29.5l24.4-114H218.7 M175.1,193.1l-30.7,77.6l-12.4-66c-1.5-7.4-7.2-11.6-13.6-11.6H68.2 l-0.7,3.3c10.3,2.2,22,5.8,29.1,9.7c4.3,2.4,5.6,4.4,7,10l23.5,91h31.2l47.8-114H175.1"
}));

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "29.3,205.1 388.9,72.7 470.7,294.9 111.1,427.3  "
});

var SvgVisaLogo = function SvgVisaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3406,
    y1: 0.01976417,
    x2: 1.0735,
    y2: 0.01976417,
    gradientTransform: "matrix(419.708 -154.5691 154.5691 419.708 -45.5254 349.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#254AA5"
    }
  })), _ref4)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VisaLogo.26669d6c.svg";
export { ForwardRef as ReactComponent };